export default function RolesService($http, API_SERVER, Log, $q, DummyApi) {
    var fn = this;

    /**
     * API V3
     */

    fn.get = function (id) {
        // Endpoint:
        let endpoint = `/roles/`;

        if (id) {
            endpoint = `/roles/${id}`;
        }

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: true }).then(function (res) {
            return res.data;
        });
    };

    return fn;
}
